import styled from "styled-components";

export const StdLiveCardStyle = styled.div`
	.stdCardInfo {
		width: 100%;
		text-align: center;
		background-color: #f3f3f3;
		border: 1px solid;
		border-radius: 10px;
		padding: 10px 30px;
		.studentName {
			font-weight: 600;
			color: #757575;
		}
		.studentEmail {
			font-weight: 600;
			color: #757575;
		}

		#tick-mark {
			position: relative;
			display: inline-block;
			width: 20px;
			height: 20px;
			float: right;
		}

		#tick-mark::before {
			position: absolute;
			left: 0;
			top: 50%;
			height: 50%;
			width: 3px;
			background-color: #008000;
			content: "";
			transform: translateX(10px) rotate(-45deg);
			transform-origin: left bottom;
		}

		#tick-mark::after {
			position: absolute;
			left: 0;
			bottom: 0;
			height: 3px;
			width: 100%;
			background-color: #008000;
			content: "";
			transform: translateX(10px) rotate(-45deg);
			transform-origin: left bottom;
		}

		.close {
			position: relative;
			display: inline-block;
			width: 20px;
			height: 20px;
			float: right;
		}
		.close:hover {
			opacity: 1;
		}
		.close:before,
		.close:after {
			position: absolute;
			left: 15px;
			content: " ";
			height: 20px;
			width: 2px;
			background-color: #c40e0e;
		}
		.close:before {
			transform: rotate(45deg);
		}
		.close:after {
			transform: rotate(-45deg);
		}
	}

	@media (max-width: "1400px") {
		.stdCardInfo {
			width: 100%;
			text-align: center;
			background-color: #f3f3f3;
			border: 1px solid;
			border-radius: 10px;
			padding: 10px 30px;
			.studentName {
				font-weight: 600;
				color: #757575;
			}
			.studentEmail {
				font-weight: 600;
				color: #757575;
			}
		}
	}

	@media (max-width: "1300px") {
		.stdCardInfo {
			width: 100%;
			text-align: center;
			background-color: #f3f3f3;
			border: 1px solid;
			border-radius: 10px;
			padding: 10px 30px;
			.studentName {
				font-weight: 600;
				color: #757575;
			}
			.studentEmail {
				font-weight: 600;
				color: #757575;
			}
		}
	}

	@media (max-width: "1200px") {
		.stdCardInfo {
			width: 100%;
			text-align: center;
			background-color: #f3f3f3;
			border: 1px solid;
			border-radius: 10px;
			padding: 10px 30px;
			.studentName {
				font-weight: 600;
				color: #757575;
			}
			.studentEmail {
				font-weight: 600;
				color: #757575;
			}
		}
	}

	@media (max-width: "992px") {
		.stdCardInfo {
			width: 100%;
			text-align: center;
			background-color: #f3f3f3;
			border: 1px solid;
			border-radius: 10px;
			padding: 10px 30px;
			.studentName {
				font-weight: 600;
				color: #757575;
			}
			.studentEmail {
				font-weight: 600;
				color: #757575;
			}
		}
	}

	@media (max-width: "640px") {
		.stdCardInfo {
			width: 100%;
			text-align: center;
			background-color: #f3f3f3;
			border: 1px solid;
			border-radius: 10px;
			padding: 10px 30px;
			.studentName {
				font-weight: 600;
				color: #757575;
			}
			.studentEmail {
				font-weight: 600;
				color: #757575;
			}
		}
	}
`;
